import * as types from './types';

const INITIAL_STATE = {
  preferenceJson: {},
  preferenceJsonError: null,
  loading: false,
  isSubmitting: false,
  submitting: false,
  submitted: false,
  submitError: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GRID_PREFERENCE_LIST:
      return {
        ...state,
        preferenceJson: {
          ...state.preferenceJson,
          ...action.payload,
        },
      };

    case types.GRID_PREFERENCE_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case types.GRID_PREFERENCE_IS_SUBMITTING:
      return {
        ...state,
        isSubmitting: action.payload,
        submitted: false,
      };

    case types.GRID_PREFERENCE_LIST_ERROR:
      return {
        ...state,
        preferenceJsonError: action.payload,
      };

    case types.GRID_PREFERENCE_SAVE_ERROR:
      return {
        ...state,
        submitError: action.payload,
      };
    case types.GRID_PREFERENCE_SUBMIT:
      return {
        ...state,
        submitted: true,
      };

    case types.GRID_PREFERENCE_CLEAR_ERROR:
      return {
        ...state,
        submitted: false,
        submitError: null,
        preferenceJsonError: null,
      };
    case types.CLEAR_GRID_PREFERENCE:
      let preferenceJson = { ...state.preferenceJson };
      delete preferenceJson[action.payload];
      return {
        ...state,
        preferenceJson: preferenceJson,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/state/gridPreference/reducer.js